import React from 'react';
import {Button, Form} from "antd";

interface PrevNextButtonsProps {
  current: number;
  steps: number;
  next?: boolean;
  prev(): void;
  final?():void

}


const PrevNextButtons = ({current, prev, next, final}: PrevNextButtonsProps) => {
  return (
    <div className={"steps-action bottom-border-radius " + (current > 0 && "dark-background")}>
      {!!prev && <div style={{display: "flex", flexGrow: 1,}}>
        {current > 0 && (
          <Button className={"button-open-grey"} onClick={() => prev()}>
            Prethodno
          </Button>
        )}
      </div>}
      <div style={{display: "flex", flexGrow: 1,}}>
        <Form.Item
          className={"next-button"}
        >{next &&
          <Button htmlType="submit" className={"button-green " + (current > 0 && "margin-shift")}
                  style={{padding: "11px 30px!important"}}
                  onClick={()=> final && final()}
          >
            Sljedeće
          </Button>}
        </Form.Item>
      </div>
    </div>
  )
};

export default PrevNextButtons;
